import { LoadingButton } from "@mui/lab";
import { Button } from "@mui/material";

import { useAuthContext } from "../../Context/AuthContext";
import useSegmentTrackEvent from "../../utils/useSegmentTrackEvent";
import { AvaCaseIQFooter } from "./AvaCaseIQFooter";
import { useAvaCaseIQContext } from "./AvaCaseIQProvider";
import { useAvaContext } from "./AvaContext";
import { useAvaDialogContext } from "./AvaDialogContextProvider";
import { ASSET_NOT_REQUIRED } from "./consts";
import { PLESButton } from "./PLESButton";
import { type CaseIQFormikValues } from "./types";
import { getTextLength } from "./utils";

type Props = {
  bigWidth: boolean;
  caseIQValues: CaseIQFormikValues;
  onSubmit: () => void;
  submitted: boolean;
  isSubmitting: boolean;
};

export const AvaCreateTicketFooter = ({ bigWidth, onSubmit, submitted, isSubmitting, caseIQValues }: Props) => {
  const { caseIQConversationId, setCaseIQConversationId, setIsCaseIQOpen } = useAvaCaseIQContext();
  const { handleCloseAvaDialog } = useAvaDialogContext();
  const { setConversationId } = useAvaContext();
  const { isDoitEmployee } = useAuthContext();

  const { trackEvent } = useSegmentTrackEvent();
  const { content, platform, cloudProduct, asset } = caseIQValues;

  const isAssetNotRequired = ASSET_NOT_REQUIRED.includes(platform);

  return (
    <AvaCaseIQFooter bigWidth={bigWidth}>
      {!submitted && caseIQConversationId && (
        <Button
          variant="text"
          sx={{ pr: 2 }}
          onClick={() => {
            setCaseIQConversationId();
            setIsCaseIQOpen(false);
            trackEvent("Case IQ ticket back to chat", {
              source: "Ava",
              feature: "support ticket",
              conversationId: caseIQConversationId,
            });
          }}
        >
          Back to chat
        </Button>
      )}
      <PLESButton caseIQValues={caseIQValues} />
      <LoadingButton
        variant="contained"
        color="primary"
        sx={{ width: "fit-content" }}
        onClick={() => {
          if (submitted) {
            handleCloseAvaDialog();
            setConversationId(undefined);
          } else {
            onSubmit();
          }
        }}
        loading={isSubmitting}
        disabled={
          getTextLength(content) < 10 ||
          !platform ||
          !cloudProduct ||
          (!isAssetNotRequired && !asset) ||
          (isDoitEmployee && !caseIQValues.requester)
        }
      >
        {submitted ? "Finish" : "Submit"}
      </LoadingButton>
    </AvaCaseIQFooter>
  );
};
